module.exports = __webpack_public_path__ + "img/xczxzcgl-bg.24040fb3.png";